import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Subject, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { HeaderService } from '../header/header.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
import * as i3 from "../header/header.service";
var LoginService = /** @class */ (function () {
    function LoginService(http, router, headerService) {
        this.http = http;
        this.router = router;
        this.headerService = headerService;
        this.url = environment.apiBase;
        this.apiBaseAraya = environment.apiBaseAraya;
        this.userID = null;
        this.imgSource = new BehaviorSubject('');
        this.imgUrl = this.imgSource.asObservable();
        // Login service
        this._userActionOccured = new Subject();
    }
    LoginService.prototype.updatedImgSource = function (imgUrl) {
        this.imgSource.next(imgUrl);
    };
    Object.defineProperty(LoginService.prototype, "userActionOccured", {
        get: function () {
            return this._userActionOccured.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    LoginService.prototype.notifyUserAction = function () {
        this._userActionOccured.next();
    };
    LoginService.prototype.login = function (body) {
        var _this = this;
        localStorage.setItem('email', body.email);
        var body1 = {
            email: body.email.trim(),
            password: body.password.trim()
        };
        return this.http.post(this.url + 'api/Account/Login', body1).pipe(tap(function (res) {
            body1 = {
                email: '',
                password: ''
            };
            var session = _this.createSessionFromResponse(res, body.email.trim());
            _this.persistAuthSession(session);
            // StorageManager.
        }));
    };
    LoginService.prototype.getImageUrl = function (submainName) {
        return this.http.get(this.url + ("api/Account/GetLogoByDomainAsync/LogoByDomain/" + submainName), { responseType: 'text' }).pipe(tap(function (res) {
        }));
    };
    LoginService.prototype.getImageUrlClientId = function (clientId) {
        return this.http.get(this.url + ("api/Clients/GetCustomerLogoByClientId/" + clientId), { responseType: 'text' }).pipe(tap(function (res) {
        }));
    };
    LoginService.prototype.logout = function () {
        localStorage.clear();
        sessionStorage.clear();
        this.updatedImgSource('');
        // this.router.navigate(['/']);
    };
    LoginService.prototype.hasActiveSession = function () {
        return !!localStorage.getItem('token');
    };
    LoginService.prototype.getStoredSession = function () {
        var token = localStorage.getItem('token');
        var roleId = localStorage.getItem('roleId');
        var clientId = localStorage.getItem('clientId');
        var clientName = localStorage.getItem('clientName');
        var firstName = localStorage.getItem('name');
        var userId = localStorage.getItem('userId');
        var isPwdVerified = localStorage.getItem('first');
        var email = localStorage.getItem('email') || undefined;
        // Client name can be empty for certain accounts (e.g. PBM/SSO); don't block a valid session on it.
        var normalizedClientName = clientName || '';
        if (!token || !roleId || !firstName || !userId || isPwdVerified == null) {
            return null;
        }
        return {
            token: token,
            roleId: roleId,
            clientId: this.parseClientId(clientId),
            clientName: normalizedClientName,
            firstName: firstName,
            userId: userId,
            isPwdVerified: this.parseBoolean(isPwdVerified),
            email: email
        };
    };
    LoginService.prototype.persistAuthSession = function (session) {
        if (!session || !session.token) {
            throw new Error('Missing authentication session data.');
        }
        sessionStorage.clear();
        localStorage.setItem('clientId', session.clientId != null ? String(session.clientId) : '');
        localStorage.setItem('roleId', session.roleId);
        localStorage.setItem('token', session.token);
        localStorage.setItem('name', session.firstName);
        localStorage.setItem('first', String(session.isPwdVerified));
        localStorage.setItem('clientName', session.clientName);
        localStorage.setItem('userId', session.userId);
        if (session.email) {
            localStorage.setItem('email', session.email);
        }
        this.headerService.updatedCompanyName(session.clientName);
        this.notifyUserAction();
    };
    LoginService.prototype.determinePostLoginNavigation = function (session) {
        if (!session) {
            return null;
        }
        var navFlag = localStorage.getItem('navFlag');
        if (navFlag !== undefined && navFlag !== null) {
            return {
                commands: ['adjuster/memberprofile']
            };
        }
        var isPwdVerified = session.isPwdVerified;
        if (session.roleId === '1') {
            if (!isPwdVerified) {
                return { commands: ['changepassword'] };
            }
            return { commands: ['admin/home'], showLoader: true };
        }
        if (session.roleId === '2') {
            if (!isPwdVerified) {
                return { commands: ['changepassword'] };
            }
            return { commands: ['client/home'] };
        }
        // Default: adjuster or other roles
        if (!isPwdVerified) {
            return { commands: ['changepassword'] };
        }
        var isFromPreApproved = localStorage.getItem('isFromPreAppoved');
        if (isFromPreApproved) {
            return { commands: ['adjuster/PendingAuthorizations'] };
        }
        return { commands: ['adjuster/home'] };
    };
    LoginService.prototype.createSessionFromResponse = function (res, email) {
        if (!res) {
            throw new Error('Invalid authentication response.');
        }
        var firstName = res.firstName || res.FirstName || '';
        var roleId = res.roleId != null ? String(res.roleId) : '';
        var clientName = res.clientName || res.ClientName || '';
        var userId = res.userId || res.UserId || '';
        var isPwdVerifiedValue = res.isPwdVerified !== undefined ? res.isPwdVerified : res.IsPwdVerified;
        var clientIdValue = res.clientId !== undefined ? res.clientId : res.ClientId;
        var token = res.token || res.Token;
        return {
            token: token,
            firstName: firstName,
            roleId: roleId,
            clientId: this.parseClientId(clientIdValue),
            clientName: clientName,
            userId: userId,
            isPwdVerified: this.parseBoolean(isPwdVerifiedValue),
            email: email || localStorage.getItem('email') || undefined
        };
    };
    LoginService.prototype.parseClientId = function (clientId) {
        if (clientId === null || clientId === undefined || clientId === '') {
            return null;
        }
        var parsed = Number(clientId);
        return Number.isNaN(parsed) ? clientId : parsed;
    };
    LoginService.prototype.parseBoolean = function (value) {
        if (typeof value === 'boolean') {
            return value;
        }
        if (typeof value === 'string') {
            return value === 'true' || value === '1';
        }
        if (typeof value === 'number') {
            return value === 1;
        }
        return false;
    };
    LoginService.ngInjectableDef = i0.defineInjectable({ factory: function LoginService_Factory() { return new LoginService(i0.inject(i1.HttpClient), i0.inject(i2.Router), i0.inject(i3.HeaderService)); }, token: LoginService, providedIn: "root" });
    return LoginService;
}());
export { LoginService };
